import React from 'react';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

import { Article } from '../../../interfaces/homepage';
import ProArticles from './ProArticles';
import ProCTA from './ProCTA';
import ProHero from './ProHero';
import ProQuote from './ProQuote';
import ProSubscription from './ProSubscription';
import ProTeams from './ProTeams';

interface ProProps {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
  proArticles: Article[];
}

const Pro = ({ env, initialCurrentUser, isWebview, proArticles }: ProProps) => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <div className="px-16 sm:px-28">
        <div className="m-auto max-w-[1040px] overflow-hidden" id="pro-landing-page">
          <ProHero />
          <ProQuote />
          <ProSubscription />
          <ProCTA />
          <ProArticles proArticles={proArticles} />
        </div>
      </div>
      <ProTeams />
    </AppContextProvider>
  );
};

export default Pro;
